import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CollectionService } from '../ApplicationServices/CollectionService';
declare const $:any;

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  searchKey: string = '';
  itemData: any;
  options: any[] = [];
  filteredOptions1: any[];

  constructor(private collectionService: CollectionService, private router: Router) { }

  ngOnInit(): void {
    this.getFillSKUWithoutID();

    $('nav.mobilemenu__nav').meanmenu({
      meanMenuClose: 'X',
      meanMenuCloseSize: '18px',
      meanScreenWidth: '991',
      meanExpandableChildren: true,
      meanMenuContainer: '.mobile-menu',
      onePage: true
    });
  }

  getFillSKUWithoutID() {
    this.collectionService.getAllItemBasic2VariationByItemProductTypeMainId(0)
      .subscribe((data: any) => {
        this.itemData = data.filter((test, index, array) => {
          return index === array.findIndex((findTest) =>
            findTest.SearchKeywordsWords === test.SearchKeywordsWords
          )
        });
        this.options = this.itemData.filter((option) => {
          return option.SearchKeywordsWords != null
        })
      });
  }

  onSeachDropdownValue($event) {
    const value = $event.target.value;
    this.filteredOptions1 = this.filter1(value);
  }

  filter1(name: string) {
    const filterValue = name.toLowerCase();
    if (filterValue != '') {
      return this.options.filter(
        (option) => option.SearchKeywordsWords.toLowerCase().indexOf(filterValue) === 0
      );
    }
  }

  onSelectDropdownValue(option) {
    this.searchKey = option.SearchKeywordsWords;
    this.filteredOptions1 = [];
    this.router.navigate(['./search-bar'], { queryParams: { searchKey: this.searchKey } });
  }

  onSearchKeywordValue(searchKeyword) {
    this.searchKey = searchKeyword;
    this.filteredOptions1 = [];
    this.router.navigate(['./search-bar'], { queryParams: { searchKey: this.searchKey } });
  }

}
